import { Card } from "@heroui/react";

import { AppLogo } from "@/src/components/AppLogo";
import { LocaleToggle } from "@/src/components/LocaleToggle";
import { ThemeToggle } from "@/src/components/ThemeToggle";
import { useTranslations } from "@/src/i18n/i18n";
import { BrandPanel } from "@/src/pages/SignIn/components/BrandPanel";
import { SignInForm } from "@/src/pages/SignIn/components/SignInForm";

/**
 * Écran de connexion (`/sign-in`) — seul point d'entrée de l'admin.
 *
 * Deux colonnes à partir de `lg` : le panneau de marque à gauche, le
 * formulaire à droite. En dessous, le panneau disparaît et le formulaire prend
 * toute la largeur — l'en-tête reprend alors le logo, qui n'est visible que là.
 */
export function SignIn() {
  const t = useTranslations("signIn");

  return (
    <main className="grid min-h-dvh lg:grid-cols-[1.1fr_1fr]">
      <BrandPanel />

      {/*
        `min-w-0` n'est pas décoratif : un item de grille a `min-width: auto`,
        donc sa piste s'élargit jusqu'au `max-content` de son contenu. Le
        `w-full max-w-sm` en dessous compte alors pour 384 px pleins et la
        colonne déborde de l'écran sur mobile. Remettre le minimum à zéro rend
        la piste compressible.
      */}
      <div className="relative flex min-w-0 items-center justify-center px-6 py-12 sm:px-10">
        {/* Langue et thème vont ensemble : deux réglages d'affichage, un seul
            endroit où les chercher. */}
        <div className="absolute top-5 right-5 flex items-center gap-2">
          <LocaleToggle />
          <ThemeToggle />
        </div>

        <div className="flex w-full max-w-sm flex-col gap-8">
          <header className="flex flex-col items-center gap-4 text-center lg:items-start lg:text-left">
            <AppLogo className="size-12 rounded-2xl lg:hidden" />

            <div className="flex flex-col gap-1.5">
              <h1 className="text-2xl font-semibold tracking-tight">
                {t("title")}
              </h1>
              <p className="text-sm text-pretty text-muted">{t("subtitle")}</p>
            </div>
          </header>

          {/*
            Le rembourrage se règle sur la `Card` elle-même : `Card.Content`
            n'en a aucun, et lui en donner un s'ajouterait à celui de la carte
            au lieu de le remplacer.
          */}
          <Card className="p-6 sm:p-8">
            <Card.Content>
              <SignInForm />
            </Card.Content>
          </Card>
        </div>
      </div>
    </main>
  );
}
